/**
 * Returns a promise that resolves after `duration` ms.
 */
export function timeoutPromise(duration: number): Promise<void> {
   return new Promise(resolve => {
      setTimeout(resolve, duration);
   });
}
